<template>
    <div>
        <!-- Common main element parameters-->
        <div class="d-flex flex-column align-items-center">
            <!-- common_metros_por_tramo -->
            <editParameterValueComponent ref="editParameterValueComponent" :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['common_metros_por_tramo']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['common_metros_por_tramo'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>
            <!-- common_distancia_soportes -->
            <editParameterValueComponent ref="editParameterValueComponent" :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['common_distancia_soportes']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['common_distancia_soportes'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>
        </div>

        <!-- DIAGRAMA -->
        <div :class="['w-100', 'portico60-container', (helper.esTecho() ? 'portico60-techo' : helper.esSuelo() ? 'portico60-suelo' : ''), (helper.esPared() ? 'portico60-pared' : '')]"
            :key="refreshKey">
            <!-- TECHO -->
            <div v-if="helper.esTecho()" class="portico60-barra-techo">
                <barra-component :soporte1="false" :soporte2="false" :vertical="false" :pared="true"
                    :length100percent="true" />
            </div>
            <!-- NIVELES -->
            <div v-for="(nivel) in helper.listaNiveles()" class="row borderX" :key="nivel"
                :style="'height: ' + alturaNivel(nivel) + 'px'">
                <!-- 3 columnas -->
                <div v-if="false" class="col-3 borderX">
                    <p v-if="nivel <= helper.niveles()">
                        Nivel {{ nivel }}
                    </p>
                </div>
                <div
                    :class="['d-flex', (helper.esTecho() ? 'align-items-end' : 'align-items-start'), 'col-9', 'borderX']">
                    <!-- LATERALES -->
                    <div v-if="mostrarLateralIzquierdo(nivel)" class="portico60-barra-vertical-left">
                        <barra-component v-if="helper.esPared()" :soporte1="false" :soporte2="false" :pared="true"
                            :vertical="true" :length="alturaTotal() + 150" />
                        <barra-component v-else :soporte1="helper.esTecho()" :soporte2="helper.esSuelo()"
                            :vertical="true" :length="alturaTotal()" />
                    </div>
                    <div v-if="mostrarLateral(nivel)" class="portico60-barra-vertical-right">
                        <barra-component :soporte1="helper.esTecho()" :soporte2="helper.esSuelo()" :vertical="true"
                            :length="alturaTotal()" />
                    </div>
                    <div class="col-12 ">
                        <!-- Bandejas -->
                        <div class="portico60-nivel-bandejas d-flex align-items-end justify-content-center">
                            <div v-for="(bandeja, key, index) in helper.bandejasNivel(nivel)"
                                style="display:inline-block; cursor:pointer" class="border2X mr-1" :key="key"
                                @click.override="editBandeja(key)">
                                <bandeja66 v-if="bandeja.modelo_bandeja.value.id == 'bandeja_66'" :main-element="bandeja" />
                                <bandeja67 v-else-if="bandeja.modelo_bandeja.value.id == 'bandeja_67'" :main-element="bandeja"/>
                                <button v-else class="btn btn-primary">
                                    Editar {{ key }}
                                </button>
                            </div>

                            <button class="btn btn-outline-dark btn_rounded btn_size ml-3"
                                @click="helper.añadirBandeja(nivel)">
                                <!-- Añadir -->
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>

                        <!-- Barra horizontal: Mostrar si es <= helper.niveles() -->
                        <div class="portico60-barra-horizontal" v-if="nivel <= helper.niveles()">
                            <barra-component :soporte1="true" :soporte2="true" :vertical="false"
                                :length100percent="true" />
                        </div>
                    </div>
                </div>
                <div class="col-3 borderX">
                    <alturas-component v-if="nivel <= helper.niveles()" :nivel="nivel"
                        @update:value="refreshParameters" />
                </div>
            </div>
            <!-- SUELO -->
            <div v-if="helper.esSuelo()" class="portico60-barra-suelo">
                <barra-component :soporte1="false" :soporte2="false" :vertical="false" :pared="true"
                    :length100percent="true" />
            </div>
        </div>

        <!-- CROQUIS flex centrado -->
        <div class="d-flex justify-content-center col-9">
            <croquis-component />
        </div>

        <!-- MODAL -->
        <div class="modal" :class="['modal', (selectedMainElementKey ? 'show' : '')]" tabindex="-1" role="dialog"
            v-if="selectedMainElementKey">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Bandeja {{ selectedMainElement.numero_nivel.value }}-{{
                                selectedMainElement.posicion_bandeja.value }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            @click="selectedMainElementKey = null">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <element60Parameters :mainElement="selectedMainElement" @update:value="refreshParameters">
                        </element60Parameters>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="removeElement">Remove</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"
                            @click="selectedMainElementKey = null">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- diagnostics -->
        <diagnostics-component />
    </div>
</template>
<script>
import Vue from "vue";
import { app } from "../../../application.js";
import G60Helper from "./G60Helper.js";
import editParameterValueComponent from "./../../editParameterValue.vue";
import diagnosticsComponent from "../../common/diagnostics.vue";
import element60Parameters from "./element60Parameters.vue";
import bandeja66 from "./bandeja66.vue";
import bandeja67 from "./bandeja67.vue";
import alturas from "./alturas.vue";
import barra from "./barra.vue";
import croquis from "./croquis.vue";
import mainElement from "../../../models/mainElement.js";

export default {
    name: "mainElements60Component",
    data() {
        return {
            app: app,
            helper: new G60Helper(app),
            refreshKey: 0,
            selectedMainElement: null,
            selectedMainElementKey: null
        }
    },
    components: {
        editParameterValueComponent,
        diagnosticsComponent,
        element60Parameters,
        bandeja66,
        bandeja67,
        alturasComponent: alturas,
        barraComponent: barra,
        croquisComponent: croquis
    },
    computed: {
        isMobile() {
            return this.app.isMobile;
        },
    },
    methods: {
        async addBandeja(nivel) {
            await this.helper.añadirBandeja(nivel);
            this.refreshKey++;
        },
        editBandeja(key) {
            this.selectedMainElementKey = key;
            this.selectedMainElement = this.app.currentConfiguration.mainElementParameters[key];
        },
        async refreshParameters() {
            await this.app.asyncProcess()
            this.refreshKey++;
            if (this.selectedMainElementKey != null) {
                this.selectedMainElement = this.app.currentConfiguration.mainElementParameters[this.selectedMainElementKey];
            }
        },
        async removeElement() {
            if (!this.selectedMainElement) return;

            if (confirm("Are you sure you want to remove this element?") == false) return;

            let nivel = this.selectedMainElement.numero_nivel.value;
            let posicion = this.selectedMainElement.posicion_bandeja.value;

            await this.helper.eliminarBandeja(nivel, posicion);
            this.selectedMainElement = null;
            this.selectedMainElementKey = null;
            this.refreshKey++;

            await this.refreshParameters();
        },
        alturaTotal() {
            // Get total niveles
            let niveles = this.helper.niveles();
            let altura = 0;
            for (let i = 1; i <= niveles; i++) {
                altura += this.alturaNivel(i);
            }
            return altura;
        },
        alturaNivel(nivel) {
            // if is last nivel, return 100
            if( nivel == this.helper.niveles() + 1){
                return 100;
            }
            let altura = 100
            if (this.helper.esSuelo()) {

                switch (nivel) {
                    case 1:
                        altura = this.app.currentConfiguration.commonMainElementParameters.altura_suelo_nivel1.value;
                        break;
                    case 2:
                        altura = this.app.currentConfiguration.commonMainElementParameters.altura_suelo_nivel2.value;
                        break;
                    case 3:
                        altura = this.app.currentConfiguration.commonMainElementParameters.altura_suelo_nivel3.value;
                        break;
                }
            } else if (this.helper.esTecho()) {
                switch (nivel) {
                    case 1:
                        altura = this.app.currentConfiguration.commonMainElementParameters.altura_techo_nivel1.value;
                        break;
                    case 2:
                        altura = this.app.currentConfiguration.commonMainElementParameters.altura_techo_nivel2.value;
                        break;
                    case 3:
                        altura = this.app.currentConfiguration.commonMainElementParameters.altura_techo_nivel3.value;
                        break;
                }
            }
            return Math.min(500, Math.max(altura, 100) * 1.75);
        },
        mostrarLateral(nivel) {
            // Si es techo, mostrar en nivel 1
            // Si es suelo, mostrar en el ultimo nivel (helper.nivel())
            return (this.helper.esTecho() && nivel == 1) || (this.helper.esSuelo() && nivel == this.helper.niveles());
        },
        mostrarLateralIzquierdo(nivel) {
            // TODO: refactor a Helper
            return this.mostrarLateral(nivel);
        }
    }
}
</script>
<style lang="scss">
.portico60-container {
    position: relative;
    padding-left: 65px;
    margin-top: 65px;
    margin-bottom: 100px;

    .portico60-barra-techo {
        position: absolute;
        top: -45px;
        left: 0;
        right: 0;
        height: 65px;
        width: 100%;
    }

    .portico60-barra-suelo {
        position: absolute;
        bottom: -45px;
        left: 0;
        right: 0;
        height: 65px;
        width: 100%;
        .portico60-nivel-bandejas{
            bottom: 0;
        }
    }
    &.portico60-pared {
        &.portico60-suelo{
            margin-top: 165px;
            .portico60-barra-vertical-left {
                top: -150px;
            }
        }
    }
    &.portico60-suelo {
        .portico60-nivel-bandejas{
            bottom: -17px;
        }
        .portico60-barra-horizontal {
            bottom: -64px;
        }
    }

    .portico60-barra-vertical-left {
        position: absolute;
        top: 0;
        left: 65px;
        width: 65px;
        // height: 100%;
    }

    .portico60-barra-vertical-right {
        position: absolute;
        z-index: -1;
        top: 0;
        right: -65px;
        width: 65px;
        // height: 100%;
    }

    .portico60-nivel-bandejas {
        position: absolute;
        z-index: 1;
        bottom: 45px;
        left: 0;
        right: 0;
        width: 100%;
        height: 100px;
    }

    .portico60-barra-horizontal {
        position: absolute;
        z-index: -1;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 65px;
        padding-left: 30px;
        padding-right: 30px;
    }
}

.bandeja60-barra-horizontal {
    /* margin-top: -20px; */
    max-width: 100%;
    height: auto;
    padding: 0;
}
</style>